var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrandSettingsUploadLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_9225",
  "data-name": "Group 9225",
  transform: "translate(-838 -315)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_474",
  "data-name": "Ellipse 474",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(838 315)",
  style: {
    opacity: "50%"
  },
  fill: "currentColor"
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  transform: "translate(845 322)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dribbble-Light-Preview",
  transform: "translate(-380 -3519)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons",
  transform: "translate(56 160)"
}, /*#__PURE__*/React.createElement("path", {
  id: "cloud_up-_1050_",
  "data-name": "cloud_up-[#1050]",
  d: "M330.551,3363.26a4.927,4.927,0,0,0-1.542-.27,5.005,5.005,0,1,0,0,10.01h5.009v-2.01h-4.846a3.115,3.115,0,0,1-3.118-2.44,3.009,3.009,0,0,1,2.955-3.56,3.065,3.065,0,0,1,1.051.2l-.021.77a1.008,1.008,0,0,0,1.009,1.03,1,1,0,0,0,1-.87c.06-.53.15-1.18.286-1.84.808-3.99,8.224-4.85,9.526.48.513,2.11-.83,4.06-1.832,5.2v2.36a7.664,7.664,0,0,0,3.972-6.33c0-7.6-10.476-9.73-13.449-2.73Zm9.993,4.27-1.4,1.41-1.123-1.16V3379h-2v-11.14l-1.121,1.08-1.453-1.41,3.546-3.54Z",
  fill: "currentColor",
  fillRule: "evenodd"
})))))));
export { SvgBrandSettingsUploadLogo as ReactComponent };
export default __webpack_public_path__ + "static/media/BrandSettingsUploadLogo.955b8d61270794c6228b27e9e54fffad.svg";